import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/services/encryption.service';
import { TokenService } from 'src/app/services/token.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private tokenService : TokenService,private encryptService:EncryptionService) {}


    /**
     * Gestion de droit des utilisateurs
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('isLoggedin')) {
          /* Debut Check DROIT */
          let urlTest = state.url.toString();
          console.log(urlTest);
          //localStorage.setItem("id_droit", "3");
          if(localStorage.getItem("user") === null)
          {
            this.router.navigate(['/login']);
          }
          let id_droit= parseInt((JSON.parse(this.encryptService.decrypt(localStorage.getItem("user"))).droit));

          this.tokenService.startRefreshToken();
          // CHECK MODERATERU ET CQ
          if(id_droit === 4 || id_droit === 5)
          {
            // @ts-ignore
            if(urlTest === '/moderation')
            {
              return true;
            }
            else if(urlTest === '/historique')
            {
              return true;
            }
            else if(urlTest.includes('/traitement') )
            {
              return true;
            }
            else if(urlTest.includes('/cq'))
            {
              return true;
            }
            else if(urlTest.includes('/details'))
            {
              return true;
            }
          }
          // CHECK CLIENT
          if(id_droit === 3)
          {
            if(urlTest == '/historique')
            {
              return true;
            }else
            if(urlTest === '/reporting')
            {
              return true;
            }else
            if(urlTest === '/facturation')
            {
              return true;
            }else
            if(urlTest === '/reporting-op')
            {
              return true;
            }
            if(urlTest === '/reporting-globale')
            {
              return true;
            }
            if(urlTest === '/reporting-nb-rejeter')
            {
              return true;
            }
            if(urlTest === '/reporting-nb-attente')
            {
              return true;
            }
          }
          if(id_droit === 1 || id_droit === 2)
          {
            return true;
          }
          this.router.navigate(['/moderation']);
          return false;
        }

        this.router.navigate(['/login']);
        return false;
    }

}
